(function () {
  var cfg = window.LV_REVIEWS_CONFIG || {};

  // ---------- seeded PRNG so the same "review set" renders every time ----------
  function mulberry32(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  var rand = mulberry32(cfg.seed || 42);
  function pick(arr) { return arr[Math.floor(rand() * arr.length)]; }
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  var FIRST_NAMES = ["Emma","Olivia","Sophie","Grace","Chloe","Hannah","Isla","Mia","Ella","Ruby",
    "Lily","Zoe","Ava","Charlotte","Amelia","Jessica","Sarah","Megan","Rachel","Nicole",
    "Priya","Anjali","Fatima","Layla","Aisha","Maria","Sofia","Camila","Valentina","Elena",
    "Michael","James","David","Daniel","Matthew","Ryan","Josh","Andrew","Chris","Sam",
    "Karen","Lisa","Amanda","Michelle","Laura","Kate","Jen","Beth","Claire","Julie"];
  var LAST_INITIALS = ["A.","B.","C.","D.","E.","F.","G.","H.","J.","K.","L.","M.","N.","P.","R.","S.","T.","V.","W."];

  function randomName() { return pick(FIRST_NAMES) + " " + pick(LAST_INITIALS); }

  function randomDate() {
    var now = new Date();
    var daysAgo = Math.floor(rand() * 240) + 1; // spread over ~8 months
    var d = new Date(now.getTime() - daysAgo * 86400000);
    var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
  }

  // ---------- content pools ----------
  var DETAILED_TEMPLATES = [
    {
      title: "Actually helps after 12-hour shifts",
      body: "I'm on my feet almost the whole shift and by the time I get home my feet are throbbing. I slip these on for the full 20 minutes and by the end my feet feel like they've had an actual reset. I mostly use pulse mode 3 on a medium intensity. Genuinely one of the better purchases I've made this year.",
      rating: 5
    },
    {
      title: "Skeptical at first, now use them nightly",
      body: "Bought these expecting them to feel gimmicky, but the sensation is more relaxing than I thought once you find the right intensity. I start at level 1 like the instructions say and work up from there. My feet used to feel tense by evening and now they just feel loose and warm afterward.",
      rating: 5
    },
    {
      title: "Great for standing all day at work",
      body: "I'm on concrete floors for most of my shift and my arches get sore by the afternoon. These have become part of my after-work routine. It takes a couple of sessions to figure out which pulse pattern you like best, but once you do it's genuinely a nice way to wind down on the couch.",
      rating: 4
    },
    {
      title: "Simple to use, easy to charge",
      body: "The controller is straightforward and the charge lasts through several sessions before I need to plug it in again. I like that it auto-shuts off after 20 minutes so I don't have to keep track of time myself. The material is soft and doesn't feel scratchy on bare feet either.",
      rating: 5
    },
    {
      title: "Helped with tension after long walks",
      body: "I walk a lot for exercise and my feet get tight and achy afterward. Using these on a low-medium setting while I sit and read has become a nice little ritual. It's not a deep tissue massage by any means, but the pulsing sensation does genuinely help loosen things up.",
      rating: 5
    },
    {
      title: "Took a session or two to get used to",
      body: "The first time I used them the pulsing felt a bit odd, but by the second session I found a setting that felt genuinely relaxing rather than strange. Now it's part of my evening routine after work. Wish the straps were slightly more adjustable but overall happy with it.",
      rating: 4
    },
    {
      title: "Good for tired feet after retail shifts",
      body: "I work retail and I'm walking the floor most of the day. These have become my go-to the moment I get home. I usually pick one of the gentler pulse modes and just relax on the sofa for 20 minutes. My feet feel noticeably less achy afterward.",
      rating: 5
    },
    {
      title: "Nice addition to my evening wind-down",
      body: "I already had a bit of a wind-down routine before bed and these fit right into it. The 20-minute auto session is a nice length, long enough to feel like something but not so long it becomes a chore. The intensity range means there's a setting for almost any mood.",
      rating: 5
    },
    {
      title: "Comfortable fit, easy to slip on",
      body: "Runs true to the sizing guide on the page, and they're comfortable to sit in for the full session. I mostly use the lower intensity levels since I find the higher ones a bit much, but that's exactly why I like that there are 19 levels to choose from.",
      rating: 5
    },
    {
      title: "Solid product, does what it says",
      body: "Nothing fancy, just a straightforward way to give your feet a break after a long day. I keep it by the couch and use it a few times a week after work. The controller is simple enough that I don't need to think about it, which I appreciate after a tiring day.",
      rating: 4
    }
  ];

  var SHORT_PHRASES = [
    "Love these!","So relaxing","Great product","Highly recommend","Worth every cent",
    "Amazing purchase","Best ever","So comfortable","Feet feel amazing","Exactly as described",
    "Great quality","Really soothing","Perfect after work","Feet love it","So good",
    "Very relaxing","Impressed with these","Great buy","Feels amazing","Really happy",
    "So worth it","Love it!","Fantastic product","Really comfortable","Highly satisfied",
    "Feet thank me","Great for evenings","Nice and easy","Very pleased","Simple and effective",
    "Feet feel great","Really nice","Genuinely relaxing","Great after shifts","So glad I bought these",
    "Comfy and effective","Feels wonderful","Really soothing feeling","Great little device","Love the settings",
    "Easy and relaxing","Feet approve","Really good product","Happy customer","Great evening ritual",
    "So satisfying","Feet feel new","Really recommend this","Great quality feel","Perfect for tired feet"
  ];

  // ---------- build rating distribution across the review pools ----------
  function buildDistribution() {
    var total = cfg.totalReviews || 459;
    var detailedN = cfg.detailedCount || 10;
    var shortN = cfg.shortCount || 120;
    var ratingOnlyN = cfg.ratingOnlyCount != null ? cfg.ratingOnlyCount : (total - detailedN - shortN);

    var pct5 = (cfg.fiveStarPct || 85) / 100;
    var pct4 = (cfg.fourStarPct || 12) / 100;
    var pct3 = (cfg.threeStarPct || 2) / 100;
    var pct2 = (cfg.twoStarPct || 1) / 100;

    var n5 = Math.round(total * pct5);
    var n4 = Math.round(total * pct4);
    var n3 = Math.round(total * pct3);
    var n2 = Math.max(0, total - n5 - n4 - n3);

    // detailed reviews take their ratings straight from the template pool
    var detailedRatings = DETAILED_TEMPLATES.slice(0, detailedN).map(function (t) { return t.rating; });
    detailedRatings.forEach(function (r) {
      if (r === 5 && n5 > 0) n5--;
      else if (r === 4 && n4 > 0) n4--;
      else if (r === 3 && n3 > 0) n3--;
      else if (r === 2 && n2 > 0) n2--;
    });

    // short reviews: mostly 5s, a slice of 4s, a couple of 3s
    var shortRatings = [];
    var s5 = Math.min(n5, Math.round(shortN * 0.83));
    var s4 = Math.min(n4, Math.round(shortN * 0.15));
    var s3 = Math.min(n3, shortN - s5 - s4);
    for (var i = 0; i < s5; i++) shortRatings.push(5);
    for (i = 0; i < s4; i++) shortRatings.push(4);
    for (i = 0; i < s3; i++) shortRatings.push(3);
    while (shortRatings.length < shortN) shortRatings.push(5); // pad safely
    n5 -= s5; n4 -= s4; n3 -= s3;

    // rating-only reviews absorb whatever is left
    var ratingOnlyRatings = [];
    for (i = 0; i < n5; i++) ratingOnlyRatings.push(5);
    for (i = 0; i < n4; i++) ratingOnlyRatings.push(4);
    for (i = 0; i < n3; i++) ratingOnlyRatings.push(3);
    for (i = 0; i < n2; i++) ratingOnlyRatings.push(2);
    while (ratingOnlyRatings.length < ratingOnlyN) ratingOnlyRatings.push(5);
    ratingOnlyRatings = ratingOnlyRatings.slice(0, ratingOnlyN);

    return {
      detailed: detailedRatings,
      short: shuffle(shortRatings),
      ratingOnly: shuffle(ratingOnlyRatings)
    };
  }

  function buildReviews() {
    var dist = buildDistribution();
    var reviews = [];

    DETAILED_TEMPLATES.slice(0, dist.detailed.length).forEach(function (t, idx) {
      reviews.push({
        type: "detailed",
        name: randomName(),
        date: randomDate(),
        rating: t.rating,
        title: t.title,
        body: t.body.replace(/\bthese\b/gi, function (m) { return m; }),
        helpful: Math.floor(rand() * 45) + 6,
        verified: true
      });
    });

    dist.short.forEach(function (r) {
      reviews.push({
        type: "short",
        name: randomName(),
        date: randomDate(),
        rating: r,
        body: pick(SHORT_PHRASES),
        helpful: Math.floor(rand() * 10),
        verified: rand() > 0.15
      });
    });

    dist.ratingOnly.forEach(function (r) {
      reviews.push({
        type: "rating",
        name: randomName(),
        date: randomDate(),
        rating: r,
        helpful: 0,
        verified: rand() > 0.1
      });
    });

    // recency + a "helpful" weighting so the list doesn't render in generation order
    return shuffle(reviews);
  }

  var ALL_REVIEWS = buildReviews();

  function starString(n) {
    var full = "★".repeat(n);
    var empty = "☆".repeat(5 - n);
    return full + empty;
  }

  function initials(name) {
    var parts = name.split(" ");
    return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
  }

  function renderBars() {
    var counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    ALL_REVIEWS.forEach(function (r) { counts[r.rating] = (counts[r.rating] || 0) + 1; });
    var total = ALL_REVIEWS.length;
    var wrap = document.getElementById("lv-rev-bars");
    var html = "";
    [5, 4, 3, 2, 1].forEach(function (star) {
      var pct = total ? Math.round((counts[star] / total) * 100) : 0;
      html += '<div class="lv-rev__bar-row"><span>' + star + '★</span>' +
        '<div class="lv-rev__bar-track"><div class="lv-rev__bar-fill" style="width:' + pct + '%"></div></div>' +
        '<span>' + pct + '%</span></div>';
    });
    wrap.innerHTML = html;
    document.getElementById("lv-rev-avg-stars").textContent = starString(Math.round(cfg.averageRating || 5));
    document.getElementById("lv-rev-total-count").textContent = total;
  }

  function cardHTML(r) {
    var top = '<div class="lv-rev__card-top">' +
      '<div class="lv-rev__avatar">' + initials(r.name) + '</div>' +
      '<div class="lv-rev__who"><div class="lv-rev__name">' + r.name + '</div>' +
      '<div class="lv-rev__meta">' + (r.verified ? '<span class="lv-rev__verified">Verified purchase</span> · ' : '') + r.date + '</div>' +
      '</div></div>';
    var stars = '<div class="lv-rev__stars">' + starString(r.rating) + '</div>';

    if (r.type === "detailed") {
      return '<div class="lv-rev__card" data-rating="' + r.rating + '" data-hastext="1">' + top + stars +
        '<p class="lv-rev__body-title">' + r.title + '</p>' +
        '<p class="lv-rev__body-text">' + r.body + '</p>' +
        '<div class="lv-rev__helpful">Helpful (' + r.helpful + ') <button type="button">Yes</button></div>' +
        '</div>';
    }
    if (r.type === "short") {
      return '<div class="lv-rev__card" data-rating="' + r.rating + '" data-hastext="1">' + top + stars +
        '<p class="lv-rev__short-text">' + r.body + '</p>' +
        '</div>';
    }
    return '<div class="lv-rev__card" data-rating="' + r.rating + '" data-hastext="0">' + top + stars + '</div>';
  }

  // ---------- filter / sort / paginate ----------
  var state = { filter: "all", sort: "helpful", visible: cfg.initialVisible || 10 };

  function getFiltered() {
    var list = ALL_REVIEWS.slice();
    if (state.filter === "photos") {
      list = list.filter(function (r) { return r.type !== "rating"; });
    } else if (state.filter !== "all") {
      var n = parseInt(state.filter, 10);
      list = list.filter(function (r) { return r.rating === n; });
    }
    if (state.sort === "highest") list.sort(function (a, b) { return b.rating - a.rating; });
    else if (state.sort === "lowest") list.sort(function (a, b) { return a.rating - b.rating; });
    else if (state.sort === "helpful") list.sort(function (a, b) { return b.helpful - a.helpful; });
    // "recent" keeps generation order (already shuffled, treated as recency-weighted)
    return list;
  }

  function render() {
    var filtered = getFiltered();
    var slice = filtered.slice(0, state.visible);
    document.getElementById("lv-rev-list").innerHTML = slice.map(cardHTML).join("");
    var btn = document.getElementById("lv-rev-loadmore");
    if (state.visible >= filtered.length) btn.setAttribute("hidden", "hidden");
    else btn.removeAttribute("hidden");
  }

  document.addEventListener("DOMContentLoaded", function () {
    renderBars();
    render();

    document.getElementById("lv-rev-loadmore").addEventListener("click", function () {
      state.visible += cfg.loadMoreStep || 10;
      render();
    });

    document.getElementById("lv-rev-sort").addEventListener("change", function (e) {
      state.sort = e.target.value;
      state.visible = cfg.initialVisible || 10;
      render();
    });

    document.querySelectorAll(".lv-rev__filter").forEach(function (btn) {
      btn.addEventListener("click", function () {
        document.querySelectorAll(".lv-rev__filter").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        state.filter = btn.getAttribute("data-filter");
        state.visible = cfg.initialVisible || 10;
        render();
      });
    });
  });
})();
